export enum EventSource {
  SERVICE_ADMIN = 'SERVICE_ADMIN',
  SERVICE_API = 'SERVICE_API',
  SERVICE_APP = 'SERVICE_APP',
  SERVICE_AUTH = 'SERVICE_AUTH',
  SERVICE_CONTRACT = 'SERVICE_CONTRACT',
  SERVICE_INSTITUTION = 'SERVICE_INSTITUTION',
  SERVICE_MISSION = 'SERVICE_MISSION',
  SERVICE_NOTIFICATION = 'SERVICE_NOTIFICATION',
  SERVICE_TALENT = 'SERVICE_TALENT',
  SERVICE_WORKER = 'SERVICE_WORKER',
}
